import { useState } from "react";
import { useMerchant } from "context/merchant";
import { openCloseAPI } from "../api/settingsApi";

// Дэлгүүр нээх/хаах логик. Component зөвхөн ҮҮНИЙГ дуудаад toggle харуулна.
// (context/merchant Фаз 9-д app/providers руу нүүхэд энэ import л өөрчлөгдөнө.)
export function useStoreStatus() {
  const { isOpen, saveMerchantInfo } = useMerchant();
  const [toggling, setToggling] = useState(false);

  const setOpen = async (next) => {
    setToggling(true);
    try {
      const res = await openCloseAPI({ isOpen: next });
      if (res?.success) {
        saveMerchantInfo({ isOpen: next });
        return { ok: true };
      }
      return { ok: false, error: res?.error || "Алдаа гарлаа." };
    } catch (error) {
      console.error(error);
      return { ok: false, error: "Серверийн алдаа." };
    } finally {
      setToggling(false);
    }
  };

  return { isOpen, toggling, setOpen };
}
